import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Badge } from 'mdbreact';
import { faEye } from '../../node_modules/@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import { DateUtils } from "react-day-picker";
import LogService from '../Services/LogService/logService'
import MainLayout from '../layout/layout';
import { Redirect } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


class Logs extends Component {

    constructor(props) {
        super();
        this.state = {
            LogData: { pending: false, value: [] },
            totalCount: 0,
            page: 1,
            maxPerPage: 10,
            modal: false,
            idLog: null,
            divWidth: {
                width: 30000
            },
            className: "custom-dialog",
            ChannelInput: null,
            Filter: {
                FilterCompanyCode: null,
                FilterLogLevel: null,
                Filterstartdate: null,
                Filterenddate: null,
                FilterChannel: null,
                FilterWebNode: null
            },
            ChannelList: [],
            WebNodeList: [],
            SelectChannel: "",
            SelectWebNode: "",
            SelectCompanyCode: "",
            isAutenticated: true,
        };
        this.toggle = this.toggle.bind(this);
        this.getLogsByID = this.getLogsByID.bind(this);
        this.companyCodeValue = this.companyCodeValue.bind(this);
        this.LogLevelValue = this.LogLevelValue.bind(this);
        this.LogChannelValue = this.LogChannelValue.bind(this);
        this.LogWebNodeValue = this.LogWebNodeValue.bind(this);
        this.handleChangeChannel = this.handleChangeChannel.bind(this);
        this.handleChangeWebNode = this.handleChangeWebNode.bind(this);
        this.hanldeKeyPress = this.hanldeKeyPress.bind(this);
    }

    startdate;
    enddate;
    wait = 0;

    hanldeKeyPress(e) {

        if (e.keyCode === 13) {
            this.getLogsByParameters();
        }
    }
    handleChangeChannel(event) {

        var value = event.target.value;

        let stateCopy = Object.assign({}, this.state);
        stateCopy.SelectChannel = value;
        stateCopy.Filter.FilterChannel = value;
        this.setState(stateCopy);

        this.getLogsByParameters();
    }
    handleChangeWebNode(event) {

        var value = event.target.value;

        let stateCopy = Object.assign({}, this.state);
        stateCopy.SelectWebNode = value;
        stateCopy.Filter.FilterWebNode = value;
        this.setState(stateCopy);

        this.getLogsByParameters();
    }
    getStartDate(day) {

        var isDate = DateUtils.isDate(day);

        if (isDate && day) {

            if (day) {
                let newstartDate = new Date(day);
                this.startdate = newstartDate.getFullYear() + "-" + (newstartDate.getMonth() + 1) + "-" + newstartDate.getDate();
            }
            else {
                this.startdate = null;

            }
            let stateCopy = Object.assign({}, this.state);
            stateCopy.Filter.Filterstartdate = this.startdate;
            stateCopy.Filter.Filterenddate = this.state.Filter.Filterenddate;
            this.setState(stateCopy);

            this.getLogsByParameters();
        }
    }
    getEndDate(day) {

        var isDate = DateUtils.isDate(day);

        if (isDate && day) {
            if (day) {
                let newendDate = new Date(day);
                this.enddate = newendDate.getFullYear() + "-" + (newendDate.getMonth() + 1) + "-" + newendDate.getDate();
            }
            else {
                this.enddate = null;
            }
            let stateCopy = Object.assign({}, this.state);
            stateCopy.Filter.Filterstartdate = this.state.Filter.Filterstartdate;
            stateCopy.Filter.Filterenddate = this.enddate;
            this.setState(stateCopy);

            this.getLogsByParameters();
        }
    }
    handleChange = (moment) => {
        this.setState({
            moment
        });
    }
    companyCodeValue(e) {
        e.preventDefault();

        let stateCopy = Object.assign({}, this.state);
        stateCopy.Filter.FilterCompanyCode = e.target.value;
        this.setState(stateCopy);
    }
    LogLevelValue(e) {
        e.preventDefault();

        let stateCopy = Object.assign({}, this.state);
        stateCopy.Filter.FilterLogLevel = e.target.value;
        this.setState(stateCopy);

        // this.wait++;
        // setTimeout(() => {
        //     this.wait--;
        //     if (this.wait === 0)
        //         this.getLogsByParameters();
        // }, 2000);
    }
    LogChannelValue(e) {
        e.preventDefault();

        let stateCopy = Object.assign({}, this.state);
        stateCopy.Filter.FilterChannel = e.target.value;
        this.setState(stateCopy);
        this.getLogsByParameters();
    }
    LogWebNodeValue(e) {
        e.preventDefault();
        this.setState({ Filter: { FilterWebNode: e.target.value } });

        let stateCopy = Object.assign({}, this.state);
        stateCopy.Filter.FilterWebNode = e.target.value;
        this.setState(stateCopy);

        this.getLogsByParameters();
    }
    getLogsByParameters() {

        var Email = sessionStorage.getItem('email');

        this.setState({
            LogData: { pending: true, value: [] },
            totalCount: 0,
            page: 1
        });
        let dataResult = LogService.getLogs(1, 10, this.state.Filter.FilterCompanyCode, this.state.Filter.FilterLogLevel,
            this.state.Filter.FilterChannel, this.state.Filter.FilterWebNode, this.state.Filter.Filterstartdate, this.state.Filter.Filterenddate, Email);

        var that = this;

        dataResult.then(function (data) {

            that.setState({
                LogData: { pending: false, value: data.data.Logs },
                totalCount: parseInt(data.data.Log_Total_Count, 10),
                page: data.data.npage
            });
        })
    }
    toggle(e, id) {
        this.setState({
            modal: !this.state.modal,
            idLog: id
        });
    }
    getPrevPage(currentPage, maxPerPage) {
        if (parseInt(maxPerPage >= this.state.totalCount, 10))
            return 0;
        else
            return currentPage - 1;
    }
    getNextPage(currentPage, maxPerPage) {
        if (parseInt(this.state.totalCount / maxPerPage, 10) === currentPage && parseInt(this.state.totalCount % maxPerPage, 10) === 0)
            return 0;
        else if (parseInt(this.state.totalCount / maxPerPage, 10) === currentPage - 1 && parseInt(this.state.totalCount % maxPerPage, 10) > 0)
            return 0;
        else
            return currentPage + 1;
    }
    getPagesCount(maxPerPage) {
        if (parseInt(this.state.totalCount % maxPerPage, 10) > 0)
            return (this.state.totalCount / maxPerPage) + 1;
        else
            return this.state.totalCount / maxPerPage;
    }
    truncate(value) {
        var values = value.substr(30);
        if (values)
            var res = values.slice(1, 50);

        return res;
    }
    getLogsByID(id) {
        return this.state.LogData.pending ? null : this.state.LogData.value.find(x => x.id === id);
    }
    getLogs(page, maxPerPage, CompanyCode, LogLevel, Channel, WebNode, startdate, enddate) {

        var Email = sessionStorage.getItem('email');

        this.setState({
            LogData: { pending: true, value: [] },
            totalCount: 0,
            page: page
        });

        let dataResult = LogService.getLogs(page, maxPerPage, CompanyCode, LogLevel, Channel, WebNode, startdate, enddate, Email);

        var that = this;

        dataResult.then(function (data) {

            that.setState({
                LogData: { pending: false, value: data.data.Logs },
                totalCount: parseInt(data.data.Log_Total_Count, 10),
                page: data.data.npage
            });
        })
    }
    componentDidMount() {

        var that = this;
        var stateCopy = "";
        if (that.props.history.location !== null && that.props.history.location.state !== undefined && that.props.history.location.state.details !== "") {

            if (that.props.history.location.state.details.channel) {
                stateCopy = Object.assign({}, that.state);
                stateCopy.Filter.FilterChannel = that.props.history.location.state.details.channel;
                stateCopy.Filter.FilterWebNode = "";
                stateCopy.Filter.Filterstartdate = that.props.history.location.state.details.startdate;
                stateCopy.Filter.Filterenddate = that.props.history.location.state.details.enddate;
                stateCopy.SelectChannel = that.props.history.location.state.details.channel;
                stateCopy.Filter.FilterCompanyCode = that.props.history.location.state.details.companyCode;
            }
            if (that.props.history.location.state.details.webnode) {
                stateCopy = Object.assign({}, that.state);
                stateCopy.Filter.FilterChannel = "";
                stateCopy.Filter.FilterWebNode = that.props.history.location.state.details.webnode;
                stateCopy.Filter.Filterstartdate = that.props.history.location.state.details.startdate;
                stateCopy.Filter.Filterenddate = that.props.history.location.state.details.enddate;
                stateCopy.SelectWebNode = that.props.history.location.state.details.webnode;
                stateCopy.Filter.FilterCompanyCode = that.props.history.location.state.details.companyCode;
            }
            if (that.props.history.location.state.details.companyCode) {
                stateCopy = Object.assign({}, that.state);
                stateCopy.Filter.FilterCompanyCode = that.props.history.location.state.details.companyCode;
                stateCopy.Filter.Filterstartdate = that.props.history.location.state.details.startdate;
                stateCopy.Filter.Filterenddate = that.props.history.location.state.details.enddate;
                stateCopy.Filter.FilterChannel = that.props.history.location.state.details.channel ? that.props.history.location.state.details.channel : "";
                stateCopy.SelectCompanyCode = that.props.history.location.state.details.companyCode;
                stateCopy.SelectChannel = that.props.history.location.state.details.channel ? that.props.history.location.state.details.channel : "";
            }
            that.setState(stateCopy, () => {
                that.getLogsByParameters();
            });

        } else {
            // var DateInicial  = "";
            // var DateFinal = ""; 
            // var fecha = new Date();
            // var otraFecha = fecha.setDate(fecha.getDate() - 7);
            if (that.state.Filter.Filterstartdate === null) {
                // var date = new Date(otraFecha);
                // DateInicial = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();        
            } else {
                // DateInicial = that.state.Filter.Filterstartdate;
            }
            if (that.state.Filter.Filterenddate === null) {
                // var Final = new Date();
                // DateFinal = Final.getFullYear() + "-" + (Final.getMonth() + 1) + "-" + Final.getDate();    
            } else {
                // DateFinal = that.state.Filter.Filterenddate;
            }
            //function LogList

            this.getLogsByParameters();
        }
        that.getAllChannel();
        that.getAllWebNode();

    }
    getLogListByFilters() {

        var that = this;
        var email = sessionStorage.getItem('email');

        let dataResult = LogService.getLogs(this.state.page, this.state.maxPerPage, this.state.Filter.FilterCompanyCode, this.state.Filter.FilterLogLevel,
            this.state.Filter.FilterChannel, this.state.Filter.FilterWebNode, this.state.Filter.Filterstartdate, this.state.Filter.Filterenddate, email);

        dataResult.then(function (data) {
            if (data.statusText === "OK") {
                that.setState({
                    LogData: { pending: false, value: data.data.Logs },
                    totalCount: parseInt(data.data.Log_Total_Count, 10),
                    page: data.data.npage,
                });
            }
        }).catch((error) => {
            that.setState({
                LogData: { pending: false, value: [] },
                totalCount: 0,
                page: 1
            });
            if (error.response) {
                if (error && error.response && error.response.data.Message === "500") {
                    toast.error("Error Data Base(Error: 500)", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NoDB") {
                    toast.error("Company Code dosen't exist!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NotReseller") {
                    toast.error("This User does not have permission!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data.Message === "400") {
                    toast.error("API Error for Reseller", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error.response.status === 401) {
                    sessionStorage.setItem("user", '');
                    sessionStorage.setItem("token", '');
                    sessionStorage.setItem("rol", '');
                    sessionStorage.setItem("email", '');
                    sessionStorage.clear();
                    this.setState({ isAutenticated: false },
                        () => {
                            this.forceUpdate();
                        })
                }
            } else {
                toast.error("Code Error", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        });
    }
    getAllChannel() {

        let dataResult = LogService.getAllChannel();
        var that = this;
        let stateCopy = Object.assign({}, that.state);
        dataResult.then(function (data) {
            data.data.map((elem) => {
                stateCopy.ChannelList.push(elem.Channel_type)
                return console.log();
            });
        })
    }
    getAllWebNode() {
        let dataResult = LogService.getAllWebNode();
        var that = this;
        let stateCopy = Object.assign({}, that.state);
        dataResult.then(function (data) {
            data.data.map((elem) => {
                stateCopy.WebNodeList.push(elem.WebNode_type)
                return console.log();
            });
        })
    }
    OtherDate() {
        var fecha = new Date();
        var otraFecha = fecha.setDate(fecha.getDate() - 7);
        var date = new Date(otraFecha);
        var Result = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
        return Result;
    }
    renderPages() {

        let pages = [];
        let pagesCount = parseInt(this.getPagesCount(this.state.maxPerPage), 10);
        let pagesShow = pagesCount > 5 ? 5 : this.getPagesCount(this.state.maxPerPage);
        let startPagination = pagesCount <= 5 ? 1 : (this.state.page - 3 <= 0 ? 1 : (this.state.page + 2 > pagesCount ? pagesCount - 4 : this.state.page - 2));
        for (let i = startPagination; i <= startPagination + pagesShow - 1; i++) {
            pages.push(<li key={i} className={this.state.page === i ? "page-item active" : "page-item"} onClick={(event) => {
                event.preventDefault(); this.getLogs(i, this.state.maxPerPage, this.state.Filter.FilterCompanyCode, this.state.Filter.FilterLogLevel,
                    this.state.Filter.FilterChannel, this.state.Filter.FilterWebNode, this.state.Filter.Filterstartdate, this.state.Filter.Filterenddate)
            }}><a className="page-link">{i}</a></li>);
        }
        return pages
    }
    renderNextPage() {
        let next_page = this.getNextPage(this.state.page, this.state.maxPerPage);
        let pagesCount = parseInt(this.getPagesCount(this.state.maxPerPage), 10);
        let nextpages = [];
        if (next_page !== 0) {
            nextpages.push(<li key="Next" className="page-item" onClick={(event) => {
                event.preventDefault(); this.getLogs(next_page, this.state.maxPerPage, this.state.Filter.FilterCompanyCode, this.state.Filter.FilterLogLevel,
                    this.state.Filter.FilterChannel, this.state.Filter.FilterWebNode, this.state.Filter.Filterstartdate, this.state.Filter.Filterenddate)
            }}>
                <a className="page-link" aria-label="Next">
                    <span aria-hidden="true">&raquo;</span>
                </a>
            </li>);
            nextpages.push(<li key="Last" className="page-item" onClick={(event) => {
                event.preventDefault(); this.getLogs(pagesCount, this.state.maxPerPage, this.state.Filter.FilterCompanyCode, this.state.Filter.FilterLogLevel,
                    this.state.Filter.FilterChannel, this.state.Filter.FilterWebNode, this.state.Filter.Filterstartdate, this.state.Filter.Filterenddate)
            }}>
                <a className="page-link" aria-label="Last">
                    <span aria-hidden="true">Last</span>
                </a>
            </li>);
        }
        else {
            nextpages.push(<li key="NextP" className="page-item disabled">
                <a className="page-link" aria-label="Next">
                    <span aria-hidden="true">&raquo;</span>
                </a>
            </li>);
            nextpages.push(<li key="LastP" className="page-item disabled">
                <a className="page-link" aria-label="Last">
                    <span aria-hidden="true">Last</span>
                </a>
            </li>);
        }
        return nextpages;
    }
    renderFirstPage() {
        let prev_page = this.getPrevPage(this.state.page, this.state.maxPerPage);
        let prevpages = [];
        if (prev_page !== 0) {
            prevpages.push(<li key="FirstT" className="page-item" onClick={(event) => {
                event.preventDefault(); this.getLogs(1, this.state.maxPerPage, this.state.Filter.FilterCompanyCode, this.state.Filter.FilterLogLevel,
                    this.state.Filter.FilterChannel, this.state.Filter.FilterWebNode, this.state.Filter.Filterstartdate, this.state.Filter.Filterenddate)
            }}>
                <a className="page-link" aria-label="First">
                    <span aria-hidden="true">First</span>
                </a>
            </li>);
            prevpages.push(<li key="FirstTT" className="page-item" onClick={(event) => {
                event.preventDefault(); this.getLogs(prev_page, this.state.maxPerPage, this.state.Filter.FilterCompanyCode, this.state.Filter.FilterLogLevel,
                    this.state.Filter.FilterChannel, this.state.Filter.FilterWebNode, this.state.Filter.Filterstartdate, this.state.Filter.Filterenddate)
            }}>
                <a className="page-link" aria-label="Previous">
                    <span aria-hidden="true">&laquo;</span>
                </a>
            </li>);
        }
        else {
            prevpages.push(<li key="FirstPP" className="page-item disabled">
                <a className="page-link" aria-label="First">
                    <span aria-hidden="true">First</span>
                </a>
            </li>);
            prevpages.push(<li key="FirstPPP" className="page-item disabled">
                <a className="page-link" aria-label="Previous">
                    <span aria-hidden="true">&laquo;</span>
                </a>
            </li>);
        }
        return prevpages;
    }
    render() {

        if (!this.state.isAutenticated) {
            return (<Redirect to={'/login'} />)
        }

        let optionItemsChannel = this.state.ChannelList.map((item, index) => {
            return <option key={index} className="dropdown-item" href="#" value={item} >{item}</option>
        });

        let optionItemsWebNode = this.state.WebNodeList.map((item, index) => {
            return <option key={index} className="dropdown-item" href="#" value={item} >{item}</option>
        });

        return (
            <div className=""><MainLayout /><ToastContainer hideProgressBar />
                <div className="container">
                    <div className="row">
                        <div className="col s12">
                            <div className="card Logs">
                                <div className="card-header">
                                    <div className="row" id="timelogs_filter">
                                        <div className="col-lg-2 col-md-2 col-sm-2">
                                            <label className="control-label" style={{ 'fontWeight': '800' }}>Company Code</label>
                                            <div className="form-group">
                                                <input className="form-control" name="companycode" id="companycode" type="text" onKeyDown={this.hanldeKeyPress} onChange={this.companyCodeValue} value={this.state.Filter.FilterCompanyCode ? this.state.Filter.FilterCompanyCode : ""} />
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-2 col-sm-2">
                                            <label className="control-label" style={{ 'fontWeight': '800' }}>Log Level</label>
                                            <div className="form-group">
                                                <input type="text" name="loglevel" id="loglevel" className="form-control" onKeyDown={this.hanldeKeyPress} onChange={this.LogLevelValue} value={this.state.Filter.FilterLogLevel ? this.state.Filter.FilterLogLevel : ""} />
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-2 col-sm-2">
                                            <label className="control-label" style={{ 'fontWeight': '900' }}>Channel</label>
                                            <select className="form-control" onChange={this.handleChangeChannel} value={this.state.SelectChannel}>
                                                <option className="dropdown-item" href="#" value="" >Select</option>
                                                {optionItemsChannel}
                                            </select>
                                        </div>
                                        <div className="col-lg-2 col-md-2 col-sm-2">
                                            <label className="control-label" style={{ 'fontWeight': '900' }}>Web Node</label>
                                            <select className="form-control" onChange={this.handleChangeWebNode} value={this.state.SelectWebNode}>
                                                <option className="dropdown-item" href="#" value="" >Select</option>
                                                {optionItemsWebNode}
                                            </select>
                                        </div>
                                        <div className="col-lg-2 col-md-2 col-sm-2">
                                            <label className="control-label" style={{ 'fontWeight': '900' }}>Start Date</label>
                                            <div className="form-group">
                                                <DayPickerInput
                                                    onDayChange={day => this.getStartDate(day)}
                                                    value={this.state.Filter.Filterstartdate ? this.state.Filter.Filterstartdate : this.OtherDate()}
                                                    format={"YYYY"}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-2 col-sm-2">
                                            <label className="control-label" style={{ 'fontWeight': '900' }}>End Date</label>
                                            <div className="form-group">
                                                <DayPickerInput
                                                    onDayChange={day => this.getEndDate(day)}
                                                    value={this.state.Filter.Filterenddate ? this.state.Filter.Filterenddate : new Date()}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <table className="table table-hover table-striped table-sm myTable">
                                        <thead>
                                            <tr>
                                                <th scope="col" style={{ 'fontWeight': '900' }}>Company Code</th>
                                                <th scope="col" style={{ 'fontWeight': '900' }}>Create Date</th>
                                                <th scope="col" style={{ 'fontWeight': '900' }}>Channel</th>
                                                <th scope="col" style={{ 'fontWeight': '900' }}>Web Node</th>
                                                <th scope="col" style={{ 'fontWeight': '900' }}>Log Level</th>
                                                <th scope="col" style={{ 'fontWeight': '900' }}>Message</th>
                                                <th scope="col" style={{ 'fontWeight': '900' }}></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.state.LogData.pending
                                                    ? <tr><td colSpan="7"><span className="loader"></span></td></tr>
                                                    :
                                                    this.state.LogData.value.length > 0
                                                        ?
                                                        this.state.LogData.value.map((item, index) => {
                                                            return <tr key={index}>
                                                                <td style={{ 'fontWeight': '400', 'padding': '0 !important' }}>{item.CompanyCode}</td>
                                                                <td style={{ 'fontWeight': '400', 'padding': '0 !important' }}>{item.CreateDate.replace("T", " ")}</td>
                                                                <td style={{ 'fontWeight': '400', 'padding': '0 !important' }}>{item.Channel}</td>
                                                                <td style={{ 'fontWeight': '400', 'padding': '0 !important' }}>{item.WebNode}</td>
                                                                <td style={{ 'fontWeight': '400', 'padding': '0 !important' }}>{item.LogLevel}</td>
                                                                <td style={{ 'fontWeight': '400', 'padding': '0 !important' }}>{this.truncate(item.Message)}</td>
                                                                <td>
                                                                    <h6>
                                                                        <a onClick={(e) => this.toggle(e, item.id)}><Badge color="warning"><FontAwesomeIcon icon={faEye} /></Badge></a>
                                                                    </h6>
                                                                </td>
                                                            </tr>;
                                                        })
                                                        :
                                                        <tr><td colSpan="7" align="center" style={{ 'fontWeight': '400', 'padding': '0 !important' }}>There are no records</td></tr>
                                            }
                                        </tbody>
                                    </table>
                                    <nav aria-label="Page navigation example">
                                        <ul className="pagination">
                                            {this.renderFirstPage()}
                                            {this.renderPages()}
                                            {this.renderNextPage()}
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal isOpen={this.state.modal} toggle={this.toggle}
                    aria-labelledby="contained-modal-title-lg"
                    className={"modal-dialog modal-notify modal-info modal-lg"}
                >
                    <ModalHeader toggle={this.toggle}><p className="heading lead">Details</p></ModalHeader>
                    <ModalBody style={{ 'maxHeight': 'calc(100vh - 250px)', 'overflowY': 'auto' }}>
                        {this.renderDetails()}
                    </ModalBody>
                    <ModalFooter>
                        <a className="btn btn-outline-info waves-effect" onClick={this.toggle}>Close</a>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
    renderDetails() {

        var element = this.getLogsByID(this.state.idLog);
        if (!element)
            return null;

        return <div className="container">
            <div className="row">
                <div className="col-md-4">
                    <span style={{ 'fontWeight': '900' }}><strong>Company Code:&nbsp;</strong></span>
                    <span id="CompanyCodeEdit" style={{ 'width': '100%', 'wordWrap': 'break-word', 'fontWeight': '400' }}>{element.CompanyCode}</span>
                </div>
                <div className="col-md-5">
                    <span style={{ 'fontWeight': '900' }}><strong>Create Date:&nbsp;</strong></span>
                    <span id="CreateDateEdit" style={{ 'width': '100%', 'wordWrap': 'break-word', 'fontWeight': '400' }}>{element.CreateDate.replace("T", " ")}</span>
                </div>
                <div className="col-md-3">
                    <span style={{ 'fontWeight': '900' }}><strong>Log Level:&nbsp;</strong></span>
                    <span id="LogLevelEdit" style={{ 'width': '100%', 'wordWrap': 'break-word', 'fontWeight': '400' }}>{element.LogLevel}</span>
                </div>
            </div> <br />
            <div className="row">
                <div className="col-6 col-md-6">
                    <span style={{ 'fontWeight': '900' }}><strong>Channel:&nbsp;</strong></span>
                    <span id="StackTraceEdit" style={{ 'width': '100%', 'wordWrap': 'break-word', 'fontWeight': '400' }}>{element.Channel}</span>
                </div>
                <div className="col-6 col-md-6">
                    <span style={{ 'fontWeight': '900' }}><strong>Web Node:&nbsp;</strong></span>
                    <span id="StackTraceEdit" style={{ 'width': '100%', 'wordWrap': 'break-word', 'fontWeight': '400' }}>{element.WebNode}</span>
                </div>
            </div><br />
            <div className="row">
                <div className="col-12 col-md-12">
                    <span style={{ 'fontWeight': '900' }}><strong>StackTrace:&nbsp;</strong></span>
                    <span id="StackTraceEdit" style={{ 'width': '100%', 'wordWrap': 'break-word', 'fontWeight': '400' }}>{element.StackTrace}</span>
                </div>
            </div><br />
            <div className="row">
                <div className="col-md-12">
                    <p style={{ 'fontWeight': '900' }}><strong>Message:</strong></p>
                    <div id="MessageEdit" style={{ 'width': '100%', 'wordWrap': 'break-word', 'fontWeight': '400' }}>{element.Message}</div>
                </div>
            </div>
        </div>
    }
}

export default Logs;



// WEBPACK FOOTER //
// ./src/log/Logs.jsx